// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCL2w_3XVXdtfhZJJ4dnCawtevPvpSVTAE',
    authDomain: 'firepoll-35b76.firebaseapp.com',
    databaseURL: 'https://firepoll-35b76.firebaseio.com',
    projectId: 'firepoll-35b76',
    storageBucket: 'firepoll-35b76.appspot.com',
    messagingSenderId: '194062897455'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
